import KycPage from './kyc-page';

export { default as KycProfile } from './components/kyc-profile';
export default KycPage;
